import axios from 'axios'
import { Message } from 'element-ui'
import { RECORD_API_BASE } from '@/config/recordApi'

/** 个人日志 API（/user/record，不走 admin JWT） */
const recordService = axios.create({
  baseURL: RECORD_API_BASE,
  timeout: 60000
})

recordService.interceptors.response.use(
  (response: any) => {
    const res = response.data
    if (res && res.code === 1) {
      return res.data
    }
    const msg = (res && res.msg) ? res.msg : '请求失败'
    Message.error(msg)
    return Promise.reject(new Error(msg))
  },
  (error: any) => {
    const msg = (error.response && error.response.data && error.response.data.msg)
      || error.message
      || '网络异常'
    Message.error(msg)
    return Promise.reject(error)
  }
)

export default recordService
